import vue from 'vue';
import { default as Component } from 'vue-class-component';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import CertificateValidation from '../../../interfaces/CertificateValidation';


@Component({
  template: require('./certificate-verification-page.html'),
})
export class CertificateVerification extends vue {
  certId = '';
  lastName = '';
  error = '';
  errors = [];
  certData = {
    cert_id: '',
    date: '',
    first_name: '',
    last_name: '',
    course: ''
  }
  loadingStatus = true;
  verification = IocContainer.get <CertificateValidation> (SERVICES.CERTIFICATEVALIDATION);

  get loading() {
    return this.loadingStatus;
  }
  get certificateData(){
    return this.certData.date.length > 0; 
  }
  verifyCertificate(){
    this.loadingStatus = false;
    this.verification.verifyCertificate(this.certId, this.lastName).then((response) => {
      this.loadingStatus = true;
      return this.certData = response.data;
  },
  (error) => {
    this.loadingStatus = true;
    this.error = 'Unable to verify the certificate';
    console.log(error);
    },
  );
  }
}